import { hasLocale } from "utilities/locale";
import { dispatchNow } from "store";
import { setMenu } from "utilities/UI/uiSlice";
import { navigate as GatsbyNavigate } from "gatsby";

const navigateBack = () => {
  if (window.location.href.includes("/contest/")) {
    navigate("/pickems/");
  } else {
    GatsbyNavigate(-1);
  }
  return false;
};

const navigate = (
  to = "/",
  noLang = false,
  options: { replace?: boolean } = {},
) => {
  let prefix = "";

  if (
    typeof window !== "undefined" &&
    !noLang &&
    !hasLocale(to, window.___currentLocale)
  ) {
    prefix =
      window.___currentLocale === window.___defaultLocale
        ? ""
        : `/${window.___currentLocale}`;
  }

  dispatchNow(setMenu("none"));

  return GatsbyNavigate(
    `${prefix}${to.startsWith("/") ? "" : "/"}${to}`,
    options,
  );
};

export { navigate, navigateBack };
